import { render, staticRenderFns } from "./Layouts.vue?vue&type=template&id=513e6c94"
import script from "./Layouts.vue?vue&type=script&lang=js"
export * from "./Layouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports